import authentication from "@irati/auth"
import {WalletEntityType} from "@irati/types"
import {QueryOptions} from "@irati/utils/services/apollo"
import AuthStream from "@irati/auth/streams/auth"
import {store} from "@irati/store"
import walletGraph from "../../graph/wallet"
import getWalletCurrency from "../../helpers/getWalletCurrency"

export const GET_WALLET = {}
export const REQUEST_WALLET = {}
export const CLEAR_WALLET = {}

export type GetWallet = (options: QueryOptions) => any

export const get = (wallet) => {
  return {
    type: GET_WALLET,
    wallet
  }
}

export const request = () => {
  return {
    type: REQUEST_WALLET
  }
}

export const getWallet = (options: QueryOptions = {}, currency: string = getWalletCurrency(authentication.userLocale())) => {
  return (dispatch) => {
    dispatch(request())
    const {user} = authentication
    return walletGraph.get(user().uuid, currency, WalletEntityType.User, options).then((wallet) => {
      return dispatch(get(wallet))
    })
  }
}

export const clear = () => {
  return {
    type: CLEAR_WALLET
  }
}

export default {
  get: getWallet,
  clear
}

function handleComplete() {
  store.dispatch(clear())
  // re-subscribe after complete as complete kills subscription
  AuthStream.subscribe(() => {}, undefined, handleComplete)
}

// have to hold a tick due to circular deps
setTimeout(() => {
  AuthStream.subscribe(() => {}, undefined, handleComplete)
})
